import { calcDH }   from './dh';
import { calcHS }   from './hs';
import { calcCSMT } from './csmt';
import { calcPW }   from './pw';
import { calcBSMT } from './bsmt';
import { calc3LHS } from './threeLiteHS';
import { calcBM }   from './bm';

export function calculateWindow(window) {
  let result;
  switch (window.type) {
    case 'DH':   result = calcDH(window);    break;
    case 'HS':   result = calcHS(window);    break;
    case 'CSMT': result = calcCSMT(window);  break;
    case 'PW':   result = calcPW(window);    break;
    case 'BSMT': result = calcBSMT(window);  break;
    case '3HS':  result = calc3LHS(window);  break;  // type code is 3HS per windowTypes.js
    case 'BM':   result = calcBM(window);    break;
    default:     throw new Error(`Unknown window type: ${window.type}`);
  }
  // Pass through per-window notes so preview and PDF can display them
  if (result && window.options) result.options = window.options;
  return result;
}

export function calculateAllWindows(windows) {
  return windows.map(w => calculateWindow(w));
}

export function collectFlexScreenOrders(calculatedWindows) {
  return calculatedWindows
    .filter(w => w.flexScreen !== null)
    .map(w => w.flexScreen);
}

export function collectGlassOrders(calculatedWindows) {
  const rows = [];
  calculatedWindows.forEach(w => {
    w.glass.forEach(g => {
      const sqFt = parseFloat(((g.width * g.height) / 144).toFixed(2));
      rows.push({
        qty:         g.qty,
        width:       g.width,
        height:      g.height,
        label:       w.label,
        glassType:   g.glassType,
        glassConfig: g.glassConfig,
        gasFill:     g.gasFill,
        grids:       g.grids,
        gridPattern: g.gridPattern,
        gridQtyV:    g.gridQtyV,
        gridQtyH:    g.gridQtyH,
        gridColor:   g.gridColor,
        sqFt,
      });
    });
  });
  return rows;
}

export function formatDimension(value) {
  if (value === null || value === undefined) return '';
  const whole   = Math.floor(value);
  const decimal = value - whole;
  const fractions = [
    { val: 0.0625, str: '1/16'  },
    { val: 0.125,  str: '1/8'   },
    { val: 0.1875, str: '3/16'  },
    { val: 0.25,   str: '1/4'   },
    { val: 0.3125, str: '5/16'  },
    { val: 0.375,  str: '3/8'   },
    { val: 0.4375, str: '7/16'  },
    { val: 0.5,    str: '1/2'   },
    { val: 0.5625, str: '9/16'  },
    { val: 0.625,  str: '5/8'   },
    { val: 0.6875, str: '11/16' },
    { val: 0.75,   str: '3/4'   },
    { val: 0.8125, str: '13/16' },
    { val: 0.875,  str: '7/8'   },
    { val: 0.9375, str: '15/16' },
  ];
  const match = fractions.find(f => Math.abs(f.val - decimal) < 0.001);
  if (match) return whole === 0 ? match.str : `${whole} ${match.str}`;
  if (decimal === 0) return `${whole}`;
  return value.toFixed(4);
}